import { BuildingMenuType } from '@/enums';
import { useConfigStore } from '@/stores';
import type { BuildingMenu } from '@/services/dto';
import type { FacilityCategoryItem } from '@/types/facility-category';
import {
    filterSelectedCategoriesByPoiContents,
    getFacilityPoiContentsFromMenu,
    mapSelectedCategoriesToFacilityItems,
} from '@/utils/facilityCategory';
import { useMemo } from 'react';

export const useFacilityCategories = (gnbMenuId?: string) => {
    const language = useConfigStore((state) => state.config.ui.language);
    const mainLanguage = useConfigStore((state) => state.config.ui.mainLanguage);
    const buildingMenus = useConfigStore((state) => state.config.server?.buildingMenus);

    const currentMenu = useMemo(() => {
        const listMenus = buildingMenus?.[language] ?? buildingMenus?.[mainLanguage] ?? [];
        if (gnbMenuId) {
            return listMenus.find((menu) => menu.id === gnbMenuId && menu.menuType === BuildingMenuType.CUSTOM_MENU);
        }
        return listMenus.find((menu) => menu.menuType === BuildingMenuType.CUSTOM_MENU);
    }, [buildingMenus, language, mainLanguage, gnbMenuId]);

    const categories = useMemo((): FacilityCategoryItem[] => {
        const menu = currentMenu as BuildingMenu | undefined;
        const poiContents = getFacilityPoiContentsFromMenu(menu);
        const filteredSelectedCategories = filterSelectedCategoriesByPoiContents(menu?.selectedCategories, poiContents);
        return mapSelectedCategoriesToFacilityItems(filteredSelectedCategories, poiContents);
    }, [currentMenu]);

    const poiContents = useMemo(() => getFacilityPoiContentsFromMenu(currentMenu as BuildingMenu | undefined), [currentMenu]);

    return {
        currentMenu,
        categories,
        poiContents,
    };
};
